import {Box, Typography} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFeather} from "@fortawesome/pro-duotone-svg-icons";
import {ORCID_ICON} from "@/src/constant/constant";
import Image from "next/image";
import React from "react";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import type Author from "@/src/_types/Authors/author";
import Link from "next/link";

const ArticleAuthors = ({authors}: { authors: Author[] }) => (
    <>
        <Box color="text.primary">
            <SpanTypography color="primary.main">
                <FontAwesomeIcon
                    icon={faFeather}
                />
            </SpanTypography>
            <SpanTypography
                fontSize={'1.25rem'}
                ml={.25}
            >
                Author(s):
            </SpanTypography>
        </Box>
        <Box
            display="flex"
            alignItems="center"
            flexWrap="wrap"
            gap={.25}
        >
            {
                authors.map((
                        author: Author,
                        index: number
                    ) =>
                        (
                            author.first_name !== ''
                            || author.middle_name !== ''
                            || author.last_name !== ''
                        ) &&
                        <Box
                            component="bdi"
                            key={`document-author-${index}`}
                            display="flex"
                            alignItems="center"
                            color="text.primary"
                        >
                            <Box
                                component="span"
                                display="inline-flex"
                                alignItems="center"
                                borderRadius="50%"
                                overflow="hidden"
                                width={17.5}
                                height={17.5}
                                mr={.25}
                                mt={.4}
                            >
                                <Image
                                    src={
                                        author.avatar ||
                                        'https://www.gravatar.com/avatar/default?d=mm&s=54'
                                    }
                                    alt={`${author.first_name
                                    }${author.middle_name ? ` ${author.middle_name}` : ''
                                    } ${author.last_name
                                    }`}
                                    width={17.5}
                                    height={17.5}
                                />
                            </Box>
                            <SpanTypography fontSize={'.875rem'}>
                                <SpanTypography fontSize={'.875rem'} mr={.25}>
                                    {
                                        `${author.first_name
                                        }${author.middle_name ? ` ${author.middle_name} ` : ''
                                        } ${author.last_name}`
                                    }
                                </SpanTypography>
                                {
                                    author.orcid &&
                                    <Link
                                        href={`https://orcid.org/${author.orcid}`}
                                        style={{marginRight: 2}}
                                    >
                                        <Image
                                            src={ORCID_ICON}
                                            width={15}
                                            height={15}
                                            style={{verticalAlign: 'middle'}}
                                            title={"ORCID"}
                                            alt={`${author.first_name
                                            }${author.middle_name ? ` ${author.middle_name}` : ''
                                            } ${author.last_name} ORCID`
                                            }
                                        />
                                    </Link>
                                }
                                <Typography
                                    component={"sup"}
                                >
                                    {
                                        author.equal_contrib === 'yes' &&
                                        '#'
                                    }
                                    {
                                        author.deceased !== '' &&
                                        author.deceased
                                    }
                                    {
                                        Object.entries(author.affiliations).map(
                                            (
                                                [
                                                    id,
                                                    label
                                                ],
                                                index,
                                                array
                                            ) => (
                                                <React.Fragment key={id}>
                                                    <Link href={`#${id}`} style={{fontSize: '.8rem', color: '#0c7f8b', textDecoration: 'none'}}>
                                                        {label as string}
                                                    </Link>
                                                    {index < array.length - 1 && ', '}
                                                </React.Fragment>
                                            ))
                                    }
                                    {
                                        (
                                            author.correspond
                                            && author.correspondence_id !== ''
                                            && author.correspondence_id !== ''
                                        ) && <>
                                            <SpanTypography fontSize={10}>,</SpanTypography>
                                            <Link
                                                href={`#${author.correspondence_id}`}
                                                style={{fontSize: '.7rem', color: '#0c7f8b', textDecoration: 'none'}}
                                            >
                                                {
                                                    author.correspondence_label
                                                }
                                            </Link>
                                        </>
                                    }
                                </Typography>
                            </SpanTypography>
                            {index !== authors.length - 1 && ', '}
                        </Box>
                )
            }
        </Box>
    </>
)

export default ArticleAuthors;